/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type BaseRequestOptionsArgs, type HttpResponse, type Rest, HttpService } from '@dm/core';
import { type UnixLocalGroup } from 'app/common/types/mo';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UnixLocalAccessGroupService {
    constructor(
        private http: HttpService,
    ) { }

    /**
     * 本地认证用户组批量查询接口
     */
    getBatchRest(vstoreId?: string): Rest {
        const rest = this.http.makeUrl('UnixLocalGroup.getBatch', undefined, true);
        if (vstoreId) {
            rest.setParams({ vstoreId });
        }
        return rest;
    }

    /**
     * 本地认证用户组数量接口
     */
    countRest(vstoreId?: string): Rest {
        const rest = this.http.makeUrl('UnixLocalGroup.count', undefined, true);
        if (vstoreId) {
            rest.setParams({ vstoreId });
        }
        return rest;
    }

    /**
     * 创建本地认证用户组
     */
    create(body: UnixLocalGroup, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('UnixLocalGroup.post');
        return this.http.post(rest, body, options);
    }

    /**
     * 修改本地认 证用户组
     */
    modify(body: UnixLocalGroup, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('UnixLocalGroup.put');
        return this.http.put(rest, body, options);
    }

    /**
     * 删除本地认证组用户
     */
    delete(name: string, vstoreId?: string, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('UnixLocalGroup.delete').setParams({ name });
        if (vstoreId) {
            rest.setParams({ vstoreId });
        }
        return this.http.delete(rest, options);
    }

    // 获取所有多租户的Rest
    getVstoreRest(): Rest {
        return this.http.makeUrl('vstore.getBatch');
    }

    // 获取单个本地认证用户组
    get(name: string, vstoreId?: string, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('UnixLocalGroup.get');
        const params: UnixLocalGroup = { name };
        if (vstoreId) {
            params.vstoreId = vstoreId;
        }
        rest.setParams(params);
        return this.http.get(rest, options);
    }
}
